import { Type } from 'class-transformer';
import { Address } from '@31third/common';
import { Token } from './token';
import { TransformBigInt } from '../util';

export class Allowance {
  @Type(() => Token)
  public token: Token;
  public target: Address;
  public done = false;
  public isApproving = false;
  public transactionId: string;
  public index: number;
  @TransformBigInt()
  public allowanceNeeded: bigint;
  public resetNeeded: boolean;
}
